export const config = {
  font: {
    _MIN_SIZE: 12,
    _MAX_SIZE: 32,
  },
  form: {
    _MIN_WIDTH: 240,
    _MAX_WIDTH: 1200,
    _DEFAULT_BG_COLOR: '#FFFFFF',
    _DEFAULT_TEXT_COLOR: '#333333',
    _DEFAULT_ADDITIONAL_TEXT_COLOR: '#737373',
  },
  field: {
    _MIN_HEIGHT: 30,
    _MAX_HEIGHT: 100,
    _MIN_WIDTH: 200,
    _MAX_WIDTH: 1000,
    _DEFAULT_BG_COLOR: '#FFFFFF',
    _DEFAULT_TEXT_COLOR: '#333333',
  },
  button: {
    _MIN_HEIGHT: 30,
    _MAX_HEIGHT: 150,
    _MIN_WIDTH: 0,
    _MAX_WIDTH: 1000,
    _MIN_BORDER_RADIUS: 0,
    _MAX_BORDER_RADIUS: 75,
    _MIN_FONT_SIZE: 12,
    _MAX_FONT_SIZE: 32,
    _DEFAULT_BG_COLOR: '#E6084B',
    _DEFAULT_TEXT_COLOR: '#FFFFFF',
    _DEFAULT_LABEL: 'Оформить заказ',
  },
};

export const fonts = [
  {
    value: 'Arial, Helvetica, sans-serif',
    label: 'Arial, Helvetica, sans-serif',
  },
  {
    value: "'Times New Roman', Times, serif",
    label: 'Times New Roman, Times, serif',
  },
  {
    value: 'Roboto, sans-serif',
    label: 'Roboto, sans-serif',
  },
  {
    value: "'Open Sans', sans-serif",
    label: 'Open Sans, sans-serif',
  },
];

export const selectorValues = [
  {
    value: 'auto',
    label: {
      id: 'iframe_constructor.сontrols.additional.selector.auto',
      defaultMessage: 'Auto',
    },
  },
  {
    value: 'show',
    label: {
      id: 'iframe_constructor.сontrols.additional.selector.show',
      defaultMessage: 'Always show',
    },
  },
  {
    value: 'hide',
    label: {
      id: 'iframe_constructor.сontrols.additional.selector.hide',
      defaultMessage: 'Always hide',
    },
  },
];


export const countrySelectorOptions = [
  {
    id: 'iframe_constructor.preview.form.select.option_1',
    defaultMessage: 'United States',
  },
  {
    id: 'iframe_constructor.preview.form.select.option_2',
    defaultMessage: 'France',
  },
  {
    id: 'iframe_constructor.preview.form.select.option_3',
    defaultMessage: 'Spain',
  },
];